import React from 'react'
import GatsbyConfig from '../../../gatsby-config.js'
import { getEl, getEls } from '../../utils/app-helpers'
import ReactTouchEvents from 'react-touch-events'
import TabbedContent from './tabbed-content'
import PrevNext from './prev-next'

const { siteMetadata: config } = GatsbyConfig

export default class Itinerary extends React.Component {
  constructor() {
    super()
    this.clickPrev = this.clickPrev.bind(this)
    this.clickNext = this.clickNext.bind(this)
    this.swipe = this.swipe.bind(this)
  }

  componentDidMount() {
    const tabsWrapper = getEl('.itinerary .tabs .wrap')

    tabsWrapper.addEventListener(
      'click',
      e => {
        if (!e.target.classList.contains('tab')) return
        this.slideToContentForTab(e.target)
      },
      false
    )
  }

  clickPrev() {
    const tabs = getEls('.itinerary .tabs .tab')
    const activeTab = getEl('.itinerary .tabs .active')
    let prevTab = activeTab && activeTab.previousElementSibling

    if (!prevTab) prevTab = tabs[tabs.length - 1]
    prevTab.click()
    this.slideToContentForTab(prevTab)
  }

  clickNext() {
    const tabs = getEls('.itinerary .tabs .tab')
    const activeTab = getEl('.itinerary .tabs .active')
    let nextTab = activeTab && activeTab.nextElementSibling

    if (!nextTab) nextTab = tabs[0]
    nextTab.click()
    this.slideToContentForTab(nextTab)
  }

  slideToContentForTab(tabEl) {
    const tabs = getEls('.itinerary .tabs .tab')
    const contents = getEls('.itinerary .contents .content')
    const index = Array.prototype.slice.call(tabs).indexOf(tabEl)
    const left = index > 0 ? index * -100 : 0

    contents.forEach(content => {
      content.setAttribute('style', `transform: translate3d(${left}%, 0, 0)`)
    })
  }

  swipe(direction) {
    switch (direction) {
      case 'right':
        this.clickPrev()
        break
      case 'left':
        this.clickNext()
        break
      default:
        break
    }
  }

  render() {
    const { trip } = this.props
    const tripData = config.trips[trip]

    return (
      <ReactTouchEvents onSwipe={this.swipe}>
        <div className="itinerary">
          <TabbedContent
            title="Itinerary"
            data={JSON.stringify(tripData.itinerary)}
          />
          <PrevNext clickPrev={this.clickPrev} clickNext={this.clickNext} />
          <p className="legal">
            * Schedule may change. Optional Activities will be available for
            purchase approximately 30 days prior to the trip.
          </p>
        </div>
      </ReactTouchEvents>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/itinerary.js